const CodeOff = () => (
  <>
    <path
      fill="currentColor"
      d="m4.113 12.006 4.24 4.24a.5.5 0 0 1 .15.345.47.47 0 0 1-.15.363.5.5 0 0 1-.353.16.5.5 0 0 1-.354-.16l-4.388-4.389a.8.8 0 0 1-.184-.267.8.8 0 0 1-.053-.298.8.8 0 0 1 .053-.298.8.8 0 0 1 .184-.268L6.633 8.06 3.094 4.521a.5.5 0 0 1-.156-.347.47.47 0 0 1 .156-.366q.166-.165.357-.166.19 0 .357.166l16.384 16.384q.147.146.156.345a.47.47 0 0 1-.156.363.5.5 0 0 1-.357.166.5.5 0 0 1-.356-.166L7.346 8.773zm13.593 2.883a.5.5 0 0 1-.165-.357.5.5 0 0 1 .165-.357l2.18-2.18-4.24-4.241a.5.5 0 0 1-.15-.345.47.47 0 0 1 .15-.363.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16l4.388 4.389a.8.8 0 0 1 .184.267q.053.136.053.298a.8.8 0 0 1-.053.298.8.8 0 0 1-.184.268l-2.329 2.328a.481.481 0 0 1-.708-.006"
    />
  </>
)
export default CodeOff
